export default __webpack_public_path__ + "static/media/cgk_sign_new.e1d41b60.jpeg";